interface ColorfulLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function ColorfulLogo({ className, size = "lg" }: ColorfulLogoProps) {
  const fontSize =
    size === "lg" ? "3.6rem" : size === "md" ? "1.5rem" : "1.1rem";

  return (
    <span
      className={`tracking-tight select-none ${className ?? ""}`}
      style={{ fontFamily: "'Hanken Grotesk', sans-serif", fontSize, lineHeight: 1 }}
    >
      <span style={{ fontWeight: 300, color: "#111827" }}>agents</span>
      <span style={{ fontWeight: 700, color: "#111827" }}>to</span>
      <span style={{ fontWeight: 300, color: "#111827" }}>go</span>
      <span style={{ fontWeight: 700, color: "#3b82f6" }}>.</span>
    </span>
  );
}
